module.exports = __webpack_public_path__ + "static/media/Group 25467.081fb446.svg";